import { addDevice, linkDevice, selfRegisterDevice } from "@/data/requests/deviceRequests"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useAddDeviceMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: addDevice,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["self"] }),
  })
}

export const useSelfRegisterDeviceMutation = () =>
  useMutation({
    mutationFn: selfRegisterDevice,
  })

// Barcode scanning
// Success and device already added are both 'successful' results for which the app should continue.
export type LinkDeviceResult = "linked" | "device-already-added"

const linkDeviceViaBarcode = async (
  params: Parameters<typeof linkDevice>[0],
): Promise<LinkDeviceResult> => {
  const response = await linkDevice(params)
  return response.code === "SUCCESS" ? "linked" : "device-already-added"
}

export const useLinkDeviceViaBarcodeMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: linkDeviceViaBarcode,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["self"] }),
  })
}
